// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2G_oR","content":"styles_content__1PnZ9","checkbox":"styles_checkbox__-_XBw","checkboxLabel":"styles_checkboxLabel__3Z_TX"};